import { useEffect, useState } from "react";
import { useGeneralContext } from "../context/AppGeneralContext";
import { useBookContext } from "../context/BookContext";
import { useHasExistingActivities } from "./useHasExistingActivities";

/**
 * Recently used books and existing activities only exist for some teachers; both are gated
 * together so they appear at once instead of popping in one after another.
 */
export const useOptionalSourcesReady = () => {
    const { userId } = useGeneralContext();
    const { loadUserRecentBooks } = useBookContext();
    const { hasActivities } = useHasExistingActivities();

    const [haveRecentBooksResolved, setHaveRecentBooksResolved] = useState(false);

    useEffect(() => {
        if (!userId) {
            setHaveRecentBooksResolved(true);
            return;
        }
        loadUserRecentBooks().finally(() => setHaveRecentBooksResolved(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        hasActivities: !!hasActivities,
        areOptionalSourcesReady: haveRecentBooksResolved && hasActivities !== undefined,
    };
};
